<template>
  <v-row class="ma-0 pa-0" v-if="!!sections && !!sections.length">
    <v-col
      cols="12"
      class="ma-0 pa-0"
      v-for="(section, index) in sections"
      :key="section.text + index"
    >
      <vetalfa-section-title v-if="section.style == 1" :prop="section.text">
      </vetalfa-section-title>
      <vetalfa-section-item-title
        v-else-if="section.style == 2 && !modifySectionItemTitle"
        :prop="section.text"
      >
      </vetalfa-section-item-title>
      <v-row
        v-else-if="section.style == 2 && !!modifySectionItemTitle"
        class="pl-2 ma-0 pa-0"
        justify="start"
        align="center"
      >
        <b class="text-start ma-0 pa-0">
          {{ section.text }}
        </b>
      </v-row>
      <vetalfa-section-item
        :index="getItemIndex(index)"
        v-else-if="section.style == 3"
        :references="section.references"
        :prop="section.text"
      >
      </vetalfa-section-item>
      <vetalfa-section-sub-item
        v-else-if="section.style == 4"
        :references="section.references"
        class="ml-5 pl-5"
        :prop="section.text"
      >
      </vetalfa-section-sub-item>
      <vetalfa-simple-table
        v-else-if="section.style == 5"
        :table="section.table"
      >
      </vetalfa-simple-table>
      <vetalfa-carousel
        v-else-if="section.style == 6"
        :contain="true"
        class="mt-2 mb-5 ma-0 pa-0"
        :items="section.photos"
        :text="section.text"
        expandCarousel
      ></vetalfa-carousel>
      <vetalfa-section-paragraph
        class="px-2"
        v-else-if="section.style == 7"
        :prop="section.text"
      >
      </vetalfa-section-paragraph>
      <vetalfa-vimeo
        :url="section.text"
        v-else-if="section.style == 8"
      ></vetalfa-vimeo>
    </v-col>
  </v-row>
</template>

<style>
</style>

<script>
import {} from "@mdi/js";
import ReferencesDialog from "@/components/ReferencesDialog.vue";
import Vimeo from "@/components/Vimeo.vue";
export default {
  name: "Sections",
  components: {
    "vetalfa-vimeo": Vimeo,
    "vetalfa-references-dialog": ReferencesDialog,
  },
  props: {
    sections: {
      type: Array,
      default: [],
      required: true,
    },
    modifySectionItemTitle: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  methods: {
    isDoseReference(section) {
      return (
        !!section.references &&
        section.references.length == 1 &&
        !!section.references[0].dose
      );
    },
    getItemIndex(index) {
      try {
        return [3, 4].includes(this.sections[index - 1].style) &&
          !this.isDoseReference(this.sections[index - 1])
          ? 1
          : 0;
      } catch (error) {
        return 0;
      }
    },
  },
  watch: {},
  data() {
    return {};
  },
  created() {},
};
</script>